export const scrollToRef = (el: HTMLDivElement | null, offset: number) => {
  if (el) window.scrollTo({ behavior: 'smooth', top: el.offsetTop - offset });
};
